import { render, staticRenderFns } from "./yhzh.vue?vue&type=template&id=2ea98ebc&scoped=true&"
import script from "./yhzh.vue?vue&type=script&lang=js&"
export * from "./yhzh.vue?vue&type=script&lang=js&"
import style0 from "./yhzh.vue?vue&type=style&index=0&id=2ea98ebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea98ebc",
  null
  
)

export default component.exports